import * as R from 'ramda'

const SELECTED_CURRENT_CHAMPIONSHIP = 'SELECTED_CURRENT_CHAMPIONSHIP'
const CLEARED_CURRENT_CHAMPIONSHIP = 'CLEARED_CURRENT_CHAMPIONSHIP'

export const selectChampionship = (tenant, championship) => ({
  type: SELECTED_CURRENT_CHAMPIONSHIP,
  payload: {
    tenant,
    championship,
  },
})

export const clearChampionship = () => ({ type: CLEARED_CURRENT_CHAMPIONSHIP })

const initialState = {
  currentTenant: undefined,
  currentChampionship: undefined,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_CURRENT_CHAMPIONSHIP:
      return {
        ...state,
        currentTenant: action.payload.tenant,
        currentChampionship: action.payload.championship,
      }
    case CLEARED_CURRENT_CHAMPIONSHIP:
      return {
        ...state,
        currentTenant: undefined,
        currentChampionship: undefined,
      }
    default:
      return state
  }
}

export default reducer

export const selectChampionshipInfo = (state) => {
  const championshipsState = state && state.championships
  const currentChampionship = championshipsState && championshipsState.currentChampionship

  return {
    name: R.prop('name', currentChampionship),
    championshipId: R.prop('id', currentChampionship),
    tenant: R.path(['championships', 'currentTenant'], state),
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/championships.ts